export default __webpack_public_path__ + "static/media/click1.dedce34a.mp3";